import { all, call, delay, fork, put, race, take, takeEvery } from "redux-saga/effects"
import { filter, isNil, map, pipe } from "ramda"
import * as R from "ramda"

import { NotificationsV1 } from "@cirrus/common/Notifications/v1"
import {
  types as notificationActionTypes,
} from "./actions.js"

function* autohideNotification(id, autohideMilliseconds) {
  const { notificationHidden } = yield race({
    delayTimeout: delay(autohideMilliseconds),
    notificationHidden: take(
      (action) =>
        (action.type === notificationActionTypes.NOTIFICATION_HIDDEN && action.payload.id === id) ||
        (action.type === notificationActionTypes.NOTIFICATIONS_HIDDEN &&
          R.indexOf(id, action.payload.ids) !== -1),
    ),
  })

  if (!isNil(notificationHidden)) return
  yield put(NotificationsV1.actions.notificationHidden(id))
}

function* onNotificationShown(action) {
  const { id, isAutohideEnabled, autohideMilliseconds } = action.payload.notification

  if (!isAutohideEnabled) return
  yield fork(autohideNotification, id, autohideMilliseconds)
}

function* onNotificationsShown(action) {
  yield all(
    pipe(
      map((notification) => {
        const { id, isAutohideEnabled, autohideMilliseconds } = notification
        return isAutohideEnabled ? call(autohideNotification, id, autohideMilliseconds) : null
      }),

      filter((effect) => !isNil(effect)),
    )(action.payload.notifications),
  )
}

export function* showNotification({ message, type, htmlEnabled }) {
  yield put(
    NotificationsV1.actions.notificationShown({
      htmlEnabled,
      message,
      type,
    }),
  )
}

export function showNotificationOn(actionType, getOptions) {
  return takeEvery(actionType, (action) => showNotification(getOptions(action)))
}

export const sagas = {
  showNotification,
  showNotificationOn
}

export default function* () {
  yield takeEvery(notificationActionTypes.NOTIFICATION_SHOWN, onNotificationShown)
  yield takeEvery(notificationActionTypes.NOTIFICATIONS_SHOWN, onNotificationsShown)
}
